import createReactComponent from '../createReactComponent';
export default createReactComponent('ease-in-out', 'IconEaseInOut', [
  ['path', { d: 'M3 20c8 0 10 -16 18 -16', key: 'svg-0' }],
]);
